import { DropdownOption } from "../models/ui/dropdownOption";

export const COUNTRY_OPTIONS: DropdownOption[] = [
  {
    label: "countries.germany",
    value: "DE",
  },
  {
    label: "countries.austria",
    value: "AT",
  },
  {
    label: "countries.switzerland",
    value: "CH",
  },
  {
    label: "countries.france",
    value: "FR",
  },
  {
    label: "countries.luxembourg",
    value: "LU",
  },
  {
    label: "countries.belgium",
    value: "BE",
  },
  {
    label: "countries.netherlands",
    value: "NL",
  },
  {
    label: "countries.denmark",
    value: "DK",
  },
  {
    label: "countries.poland",
    value: "PL",
  },
  {
    label: "countries.czechia",
    value: "CZ",
  },
  {
    label: "countries.slovakia",
    value: "SK",
  },
  {
    label: "countries.hungary",
    value: "HU",
  },
  {
    label: "countries.romania",
    value: "RO",
  },
  {
    label: "countries.israel",
    value: "IL",
  },
];
